import React from "react";
import styles from "./Template.module.css";
import LessonInstruction from "../../containers/instruction/LessonInstruction";

export const Template = ({showInstruction, instructionText, audioUrl, className, children, actionButtons}) => {

    return (
        <div className={`${styles.templateContainer} ${className ? className : ''}`}>
            {showInstruction ? (
                <LessonInstruction instructionText={instructionText} audioUrl={audioUrl} />
            ) : (
                <>
                    {children}
                </>

            )}
        </div>
    );
}